import { render, staticRenderFns } from "./UserExchange.vue?vue&type=template&id=6915645e&scoped=true&"
import script from "./UserExchange.vue?vue&type=script&lang=js&"
export * from "./UserExchange.vue?vue&type=script&lang=js&"
import style0 from "./UserExchange.vue?vue&type=style&index=0&id=6915645e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6915645e",
  null
  
)

export default component.exports